import {values} from 'lodash';
import Config from '../../../../../../Config';
const brandNameHe = () => window.Config?.brand_Name_HE ?? '';

const trackerItemText = {
  itemList: {
    followUpRefund: {
      underReview: {
        title: {
          value: 'בקשת הזיכוי שלך בבדיקה',
          MarketingId: 'FeedStatus_2001',
        },
        subTitle: {value: 'נעדכן אותך לגבי התשובה עד ה-{0}', MarketingId: 'FeedStatus_2001'},
        subTitleWithAmount: {value: 'בקשתך לזיכוי על סך {0} ₪ בטיפול. \nתשובה תתקבל עד ה - {1}.', MarketingId: 'FeedStatus_2001'},
      },
      underReviewWithSLA: {
        title: {value: 'בקשת הזיכוי שלך עדיין בבדיקה', MarketingId: 'FeedStatus_2002'},
        subTitle: {value: 'נעדכן אותך עד ה-{0}', MarketingId: 'FeedStatus_2002'},
        subTitleWithAmount: {value: 'בקשתך לזיכוי על סך {0} ₪ בטיפול. \nתשובה תתקבל עד ה - {1}.', MarketingId: 'FeedStatus_2002'},
      },
      confirmed: {
        title: {value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: 'FeedStatus_2003'},
        subTitle: {value: '', MarketingId: 'FeedStatus_2003'},
        subTitleWithAmount: {value: 'זיכוי בסך {0} ₪ יופיע בחשבונית הקרובה שלך.', MarketingId: 'FeedStatus_2003'},
      },
      notConfirmed: {
        title: {value: 'בקשת הזיכוי שלך לא אושרה', MarketingId: 'FeedStatus_2004'},
        subTitle: {value: 'לצערנו בקשת הזיכוי מתאריך {0} נדחתה', MarketingId: 'FeedStatus_2004'},
        subTitleWithAmount: {value: 'לצערנו בקשת הזיכוי בסך {0} מתאריך {1} נדחתה', MarketingId: 'FeedStatus_2004'},
      },
      notConfirmedYet: {
        title: {value: 'בקשת הזיכוי שלך בבדיקה', MarketingId: 'FeedStatus_2005'},
        subTitle: {value: 'תהיה לנו תשובה\n במועד סגירת החשבונית הבאה', MarketingId: 'FeedStatus_2005'},
        subTitleWithAmount: {value: 'בקשתך לזיכוי על סך {0} תתקבל בחשבונית הבאה', MarketingId: 'FeedStatus_2005'},
      },
      notConfirmedYetAfterInvoice: {
        title: {value: 'סיימנו את הטיפול בבקשת הזיכוי', MarketingId: 'FeedStatus_2006'},
        subTitle: {value: 'התשובה תופיע בחשבונית הבאה', MarketingId: 'FeedStatus_2006'},
        subTitleWithAmount: {value: 'בקשתך לזיכוי על סך {0} תתקבל בחשבונית הבאה', MarketingId: 'FeedStatus_2006'},
      },
    },
    refund: {
      benefitApproved: {
        title: {value: 'סיימנו את הטיפול בבקשת הזיכוי', MarketingId: ''},
        subTitle: {
          value: 'שמחים לעדכן אותך כי בקשת הזיכוי הסתיימה. \nקיבלת מאיתנו הטבת שירות שתצטרף לחשבונית של החודש הבא.',
          MarketingId: '',
        },
        subTitleWithAmount: {
          value: 'שמחים לעדכן אותך כי בקשת הזיכוי הסתיימה. \nקיבלת מאיתנו הטבת שירות בסך {1} ש"ח שתצטרף לחשבונית של החודש הבא.',
          MarketingId: '',
        },
      },
      approved: {
        title: {value: 'אישרנו את בקשת הזיכוי שלך', MarketingId: ''},
        subTitle: {value: 'הזיכוי יופיע בחשבונית הקרובה שלך', MarketingId: ''},
        subTitleWithAmount: {value: 'זיכוי בסך {1} ש"ח יופיע בחשבונית הקרובה שלך', MarketingId: 'FeedStatus_2006'},
      },
      underReview: {
        title: {value: 'בקשת הזיכוי שלך בבדיקה', MarketingId: ''},
        subTitleClosed: {value: 'תשובה תתקבל עד ה - {0}', MarketingId: ''},
        subTitle: {value: 'נפתחה  בקשה בתאריך {0}, מבטיחים לעדכן עד 6 ימי עסקים', MarketingId: ''},
        subTitleWithAmount: {value: '', MarketingId: ''},
      },
      notApproved: {
        title: {value: 'בקשת הזיכוי שלך לא אושרה', MarketingId: ''},
        subTitle: {value: 'לצערנו בקשת הזיכוי שלך מתאריך {0} נדחתה', MarketingId: ''},
        subTitleWithAmount: {value: '', MarketingId: ''},
      },
      approvedWithReview: {
        title: {value: 'אישרנו את בקשת הזיכוי', MarketingId: ''},
        subTitle: {
          value: 'הזיכוי יופיע בחשבונית של החודש הבא.\n אנחנו בודקים את האפשרות לזכות אותך גם על החודש הנוכחי ונחזיר לך תשובה עד ה - {0}',
          MarketingId: '',
        },
        subTitleWithAmount: {
          value:
            'זיכוי בסך {1} ש"ח יופיע בחשבונית של החודש הבא.\nאנחנו בודקים את האפשרות לזכות אותך גם על החודש הנוכחי ונחזיר לך תשובה עד ה - {0}.',
          MarketingId: 'FeedStatus_2006',
        },
      },
      waitForInvoice: {
        title: {value: 'בקשת הזיכוי בהמתנה', MarketingId: ''},
        subTitleClosed: {value: 'תשובה בנוגע לבקשתך תתקבל עד מועד סגירת החשבונית הבאה. עדכון יתקבל עד ה - {0}', MarketingId: ''},
        subTitle: {
          value: 'תשובה בנוגע לבקשתך תתקבל עד מועד סגירת החשבונית הבאה. עדכון יתקבל עד ה - {0}. בינתיים תוכלו לעקוב כאן אחרי הבקשה',
          MarketingId: '',
        },
        subTitleWithAmount: {value: '', MarketingId: 'FeedStatus_2006'},
      },
      processEnd: {
        title: {value: 'סיימנו לטפל בבקשת הזיכוי', MarketingId: ''},
        subTitle: {value: 'ביטלנו לך חיוב מהחשבונית', MarketingId: ''},
        subTitleWithAmount: {value: 'ביטלנו לך חיוב על סך {1} ש"ח', MarketingId: 'FeedStatus_2006'},
      },
    },
    waitingForCall: {
      title: {value: 'קבענו לדבר!', MarketingId: 'FeedStatus_200'},
      subTitle: {value: 'נחזור אליך טלפונית עד ל -{0}', MarketingId: 'FeedStatus_2008'},
    },
    changePricePlan: {
      confirmed: {
        title: {value: 'יש לך חבילה חדשה!', MarketingId: 'FeedStatus_2007'},
        subTitle: {value: 'ב-{0} עדכנו חבילת סלולר\n חדשה למנוי {1}', MarketingId: 'FeedStatus_2007'},
      },
      requestExcepted: {
        title: {value: 'יש לך חבילה חדשה!', MarketingId: 'FeedStatus_2007'},
        subTitle: {value: 'חבילת סלולר למנוי {1}\n תיכנס לתוקף ב-{0}', MarketingId: 'FeedStatus_2007'},
      },
    },
    technicianVisit: {
      title: {value: 'תיאמנו לכם טכנאי {0}', MarketingId: 'Tech_1000'},
      subTitle: {value: 'הטכנאי יגיע אליך בתאריך:  ', MarketingId: ''},
      dateTime: {value: ' {2} בין השעות {0} - {1}', MarketingId: ''},
    },
    couponReceived: {
      title: {value: "קופון חדש מחכה באזור 'הקופונים שלי'"},
    },
  },
  body: {
    abroadPackage: {
      title: {value: 'למנוי {0} יש חבילת חו"ל', MarketingId: ''},
      text: {
        value: 'לנייד {0} יש חבילת חו"ל בתוקף החל מ {1} עד {2}',
        MarketingId: '',
      },
    },
    followUpRefund: {
      underReview: {
        title: {value: 'אנחנו מטפלים בבקשת הזיכוי שלך', MarketingId: ''},
        text: {
          textWithAmount: {
            value: 'נפתחה בקשה בתאריך {0} ,מבטיחים לעדכן עד 6 ימי עסקים',
            MarketingId: '',
          },
          textNoAmount: {value: 'נפתחה בקשה בתאריך {0} ,מבטיחים לעדכן עד 6 ימי עסקים', MarketingId: ''},
        },
      },
      underReviewWithSLA: {
        title: {value: 'אנחנו מטפלים בבקשת הזיכוי שלך', MarketingId: ''},
        text: {
          textWithAmount: {
            value: 'בקשת הזיכוי מתעכבת ותטופל עד 3 ימי עסקים',
            MarketingId: '',
          },
          textNoAmount: {value: 'בקשת הזיכוי מתעכבת ותטופל עד 3 ימי עסקים', MarketingId: ''},
        },
      },
      notConfirmed: {
        title: {value: 'סטטוס בקשת זיכוי', MarketingId: ''},
        text: {
          textWithAmount: {value: 'בקשת הזיכוי מתאריך {0} לא אושרה', MarketingId: ''},
          textNoAmount: {value: 'בקשת הזיכוי מתאריך {0} לא אושרה', MarketingId: ''},
        },
      },
      confirmed: {
        title: {value: 'בקשת הזיכוי שלך אושרה', MarketingId: ''},
        text: {
          textNoAmount: {value: 'קיבלת מאיתנו זיכוי בסך {1}₪. \n אפשר יהיה לראות אותו בחשבונית של {2}', MarketingId: ''},
          textWithAmount: {value: 'קיבלת מאיתנו זיכוי בסך {1}₪. \n אפשר יהיה לראות אותו בחשבונית של {2}', MarketingId: ''},
        },
        actions: {
          editVisit: 'עדכן',
          addToCalendar: 'תזכורת ליומן',
          //deleteMessage: 'מחיקת הודעה',
        },
        get calendarEventName() {
          return `זיכוי מחברת ${brandNameHe()}`;
        },
      },
      notConfirmedYet: {
        title: {value: 'אנחנו מטפלים בבקשת הזיכוי שלך', MarketingId: ''},
        text: {
          textWithAmount: {value: 'מבטיחים לעדכן עד {2}', MarketingId: ''},
          textNoAmount: {value: 'מבטיחים לעדכן עד {2}', MarketingId: ''},
        },
      },
      notConfirmedYetAfterInvoice: {
        title: {value: 'בקשת הזיכוי שלך אושרה', MarketingId: ''},
        text: {
          textWithAmount: {value: 'קיבלת מאיתנו זיכוי בסך {1}₪. \n אפשר יהיה לראות אותו בחשבונית של {2}', MarketingId: ''},
          textNoAmount: {value: 'קיבלת מאיתנו זיכוי בסך {1}₪. \n אפשר יהיה לראות אותו בחשבונית של {2}', MarketingId: ''},
        },
        actions: {
          //deleteMessage: 'מחיקת הודעה',
        },
      },
    },
    refund: {
      benefitApproved: {
        title: {value: 'קיבלת מאיתנו הטבה בסך {1}₪', MarketingId: ''},
        subTitle: {
          value: 'אפשר יהיה לראות אותה בחשבונית של {2}',
          MarketingId: '',
        },
        subTitleWithAmount: {
          value: 'אפשר יהיה לראות אותה בחשבונית של {2}',
          MarketingId: '',
        },
      },
      approved: {
        title: {value: 'בקשת הזיכוי שלך אושרה', MarketingId: ''},
        subTitle: {value: 'הזיכוי יופיע בחשבונית הקרובה שלך', MarketingId: ''},
        subTitleWithAmount: {value: 'זיכוי בסך {1} ש"ח יופיע בחשבונית הקרובה שלך', MarketingId: ''},
      },
      underReview: {
        title: {value: 'אנחנו מטפלים בבקשת הזיכוי שלך', MarketingId: ''},
        subTitleClosed: {value: 'תשובה תתקבל עד ה - {2}', MarketingId: ''},
        subTitle: {value: 'בקשת הזיכוי שלך בבדיקה.\nתשובה תתקבל עד ה - {2}\n תוכל לעקוב כאן אחרי מצב הבקשה', MarketingId: ''},
        subTitleWithAmount: {value: '', MarketingId: ''},
      },
      notApproved: {
        title: {value: 'סטטוס בקשת זיכוי', MarketingId: ''},
        subTitle: {value: 'בקשת הזיכוי מתאריך {0} לא אושרה', MarketingId: ''},
        subTitleWithAmount: {value: 'בקשת הזיכוי מתאריך {0} לא אושרה', MarketingId: ''},
      },
      approvedWithReview: {
        title: {value: 'בקשת הזיכוי שלך אושרה', MarketingId: ''},
        subTitle: {
          value: 'זיכוי בסך {1} יופיע בתאריך {2}, זיכוי נוסף יבוצע לאחר סגירת חשבונית הבאה',
          MarketingId: '',
        },
        subTitleWithAmount: {
          value: 'זיכוי בסך {1} יופיע בתאריך {2}, זיכוי נוסף יבוצע לאחר סגירת חשבונית הבאה',
          MarketingId: 'FeedStatus_2006',
        },
      },
      waitForInvoice: {
        title: {value: 'בקשת הזיכוי בהמתנה', MarketingId: ''},
        subTitleClosed: {value: 'תשובה בנוגע לבקשתך תתקבל עד מועד סגירת החשבונית הבאה. עדכון יתקבל עד ה - {2}', MarketingId: ''},
        subTitle: {
          value: 'תשובה בנוגע לבקשתך תתקבל עד מועד סגירת החשבונית הבאה. עדכון יתקבל עד ה - {2}. בינתיים תוכלו לעקוב כאן אחרי הבקשה',
          MarketingId: '',
        },
        subTitleWithAmount: {value: '', MarketingId: 'FeedStatus_2006'},
      },
      processEnd: {
        title: {value: 'בקשת הזיכוי שלך אושרה', MarketingId: ''},
        subTitle: {value: 'ביטלנו לך את החיוב מהחשבונית של {2}', MarketingId: ''},
        subTitleWithAmount: {value: 'ביטלנו לך את החיוב מהחשבונית של {2}', MarketingId: 'FeedStatus_2006'},
      },
    },
    waitingForCall: {
      title: {value: 'קבענו לדבר', MarketingId: ''},
      text: {value: ' קבענו שנחזור אליך טלפונית עד לתאריך {0}.', MarketingId: ''},
      manager: 'מנהל שירות/מומחה טכני',
      agent: 'נציג שירות',
      techExpert: 'מומחה טכני',
      actions: {
        addToCalendar: {value: 'תזכורת ליומן', MarketingId: ''},
        deleteMessage: {value: 'בעצם, אין צורך שתחזרו אלי', MarketingId: ''},
        //deleteMessage: 'מחיקת הודעה',
      },
    },
    changePricePlan: {
      requestExcepted: {
        title: {value: 'עדכון תכנית סלולר למספר {0}', MarketingId: ''},
        text: {
          value: 'העדכון ייכנס לתוקף ב {0}.',
          MarketingId: '',
        },
        actions: {
          //deleteMessage: 'מחיקה',
        },
      },
      confirmed: {
        title: {value: 'עדכון תכנית סלולר למספר {0}', MarketingId: ''},
        text: {
          value: 'העדכון ייכנס לתוקף ב {0}.',
          MarketingId: '',
        },
        actions: {
          //deleteMessage: 'מחיקה',
        },
        get calenderEventName() {
          return `עדכון תוכנית סלולר ב${brandNameHe()}`;
        },
      },
    },
    personalReminder: {
      text1: 'בעקבות פנייתך ב-{0} לנציג שרות',
      text2: '{0} יחזור אלייך טלפונית',
      text3: 'עד לתאריך {0}',
      with: 'נציג',
    },
    technicianVisit: {
      title: {value: 'קבענו לך ביקור טכנאי', MarketingId: 'Tech_1000'},
      text: {value: 'טכנאי {0} יגיע אליך', MarketingId: 'Tech_1002'},
      dateTime: {value: '{0} - {1} | {2} ', MarketingId: 'Tech_1003'},
      addressText: {value: 'נגיע אליך לכתובת ', MarketingId: 'Tech_1003'},
      address: {value: '{0}', MarketingId: 'Tech_1003'},
      superFiber: {
        get value() {
          return `אנחנו שמחים שהצטרפת לסופר פייבר,\n האינטרנט הביתי המהיר של ${brandNameHe()}. \n בקרוב הגלישה בבית שלך תגיע עד 1,000 Mbps!`;
        },
        MarketingId: 'Tech_1003',
      },
      specialText: {
        value: '* חשוב שתהיה נוכחות מבוגר בבית, כשהטכנאי מגיע.',
        MarketingId: 'Tech_1004',
      },
      actions: {
        calenderEventName: {value: 'ביקור טכנאי {0}', MarketingId: ''},
        addToCalendar: {value: 'הוסיפו לי ליומן', MarketingId: 'Tech_1005'},
        chat: {value: 'צ׳אט עם נציג', MarketingId: 'Tech_1006'},
        editVisit: {value: 'עדכון מועד', MarketingId: 'Tech_1006'},
        deleteMessage: {value: 'ביטול טכנאי', MarketingId: 'Tech_1006'},
      },
      chatDesc: {
        get value() {
          return `פנייה בעקבות צפייה בביקור טכנאי באפליקציה ${brandNameHe()} אישי.`;
        },
        MarketingId: '',
      },
    },
    technicianVisitFiber: {
      title: {value: 'הגעת טכנאי סופר פייבר', MarketingId: 'Tech_1000'},
      desc: {
        get value() {
          return `תודה שהצטרפתם לסופר פייבר,\n
                    האינטרנט הביתי הסופר מהיר של ${brandNameHe()} \n
                    לא תאמינו כמה מהיר האינטרנט שלכם יכול להיות, רגע אחרי שהטכנאי יסיים את ההתקנה. \n
                    בקרוב גם אצלכם יגלשו (מה יגלשו? יטוסו!) במהירות של עד Mbps 1,000! \n
                    מתי זה יקרה?`;
        },
        MarketingId: 'Tech_1002',
      },
      dateTime: {value: '{0} - {1}    |    {2} ', MarketingId: 'Tech_1003'},
      address: {value: 'בכתובת:', MarketingId: 'Tech_1003'},
      specialText: {
        value: 'שים לב, בעת הגעת הטכנאי חשוב שיהיה\nמבוגר בבית.',
        MarketingId: 'Tech_1004',
      },
      actions: {
        calenderEventName: {value: 'ביקור טכנאי {0}', MarketingId: ''},
        addToCalendar: {value: 'תזכורת ליומן', MarketingId: 'Tech_1005'},
        chat: {value: 'צ׳אט עם נציג', MarketingId: 'Tech_1006'},
        editVisit: {value: 'עדכן', MarketingId: 'Tech_1006'},
      },
      chatDesc: {
        get value() {
          return `פנייה בעקבות צפייה בביקור טכנאי באפליקציה ${brandNameHe()} אישי`;
        },
        MarketingId: '',
      },
      desc4: {value: 'לכתובת {0}', MarketingId: ''},
    },
    robohold: {
      title: {value: 'שיחה מתוזמנת', MarketingId: '??'},
      subTitle: {value: 'עם מוקד שירות', MarketingId: '??'},
      text1: {
        value: 'קיימת שיחה מתוזמנת ל-{0}\nבשעה {1}\nלמוקד {2} {3}\nאנחנו נתקשר למספר {4}',
        MarketingId: '??',
      },
      actions: {
        cancel: 'אין צורך בשיחה',
      },
    },
    customerDeliveries: {
      title: {value: 'חדשות טובות, השליח שלנו עוד \n מעט יוצא אליך'},
      subTitle: {value: 'נגיע אליך ב- {0} בין השעות {1} - {2}'},
      openSubTitle: {value: 'נגיע אליך לכתובת {0} \n בתאריך {1} \n בין השעות {2} - {3}'},
      calenderEventName: {value: 'קבענו לכם מועד למשלוח'},
      addressText: {value: 'נגיע אליך לכתובת ', MarketingId: ''},
      calenderEventLocation: {value: '\nהכתובת לשם נגיע {0}'},
      calenderEventText: {
        get value() {
          return `{0} מתואמת לך שליחות ${brandNameHe()} בתאריך\n {1} אנחנו נפגש בין השעות \n בכתובת {2}\n {3} בכל שינוי ניתן להכנס`;
        },
      },
      actions: {
        addToCalendar: {value: 'להוסיף תזכורת ליומן'},
        editVisit: {value: 'לשנות מועד הגעה'},
      },
    },
    couponReceived: {
      title: {
        get value() {
          return `קיבלת קופון מ${brandNameHe()}`;
        },
      },
      subTitle: {value: 'קוד הקופון: {0}'},
      text: {value: 'הקופון תקף עד {0}'},
      actions: {
        checkCoupons: 'לצפייה בקופונים שלי',
      },
    },
  },
};

export default trackerItemText;
